import styled from 'styled-components';

export const RelatedPeopleCardsStyles = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
	gap: 0.5rem;
`;

export const RelatedPersonCardStyles = styled.div`
	width: 100%;
	overflow: hidden;
	padding: 1rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
	border-radius: 0.5rem;
	background: ${({ theme }) => theme.v3.colors.white[0]};

	&[href] {
		display: block;
		color: inherit;
		text-decoration: none;
		cursor: pointer;
	}

	&[href]:hover {
		border-color: ${({ theme }) => theme.v3.colors.gray[4]};
	}

	> .rp-header {
		display: flex;
		align-items: flex-start;
		gap: 0.5rem;
	}

	> .rp-header > .names {
		display: flex;
		flex-direction: column;
		min-width: 0;
	}

	> .tax > .tax-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 0.5rem;
		margin-bottom: 0.5rem;
	}

	> .tax > .tax-header > .more {
		padding: 0.125rem 0.5rem;
		border-radius: 1rem;
		background: ${({ theme }) => theme.v3.colors.gray[2]};
	}
`;
